import { useMemo } from 'react';
import { useThemeStore } from '@/app/theme';
import { accents, type Accent, type AccentHue } from '@/app/theme-tokens';

/** Bộ màu nhấn của chế độ đang bật (sáng/tối) — xem `ACCENT_HUES` ở `theme-tokens.ts`. */
export function useAccents(): Record<AccentHue, Accent> {
  const mode = useThemeStore((state) => state.mode);
  return useMemo(() => accents(mode), [mode]);
}

export function useAccent(hue: AccentHue): Accent {
  return useAccents()[hue];
}
